<template>
	<div>
		<ModalDetailCancelTransaction ref="ModalDetailCancelTransaction"></ModalDetailCancelTransaction>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Transaksi Ecommerce Dibatalkan</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<router-link class="text-deco" :to="{ name: 'ecommerce-add-cancel-transaction' }" v-if="hasAccess('ecommerce-add-cancel-transaction')">
						<v-btn light depressed class="primary">
							<v-icon>mdi-plus-circle</v-icon>
							<div class="pl-2 text-capitalize">Tambah Pembatalan Transaksi</div>
						</v-btn>
					</router-link>
					<v-spacer></v-spacer>
					<!-- <v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn> -->
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listData" :search="search" hide-default-footer :options.sync="option" :server-items-length="paginationData.total_data" class="table-w-100">
				<template v-slot:item.action="{ item }">
					<div class="pt-2 pb-2">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(item)" class="mr-2">
									<v-icon dark>mdi-text-box-search</v-icon>
								</v-btn>
							</template>
							<span>Detail</span>
						</v-tooltip>
					</div>
				</template>
				<template v-slot:item.trx_cancel_code="{ item }">
					<div class="pt-2">{{ item.trx_cancel_code }}</div>
				</template>
				<template v-slot:item.trx_cancel_datetime="{ item }">
					<div class="pt-2">{{ item.trx_cancel_datetime | tanggaljam}}</div>
				</template>
				<template v-slot:item.trx_cancel_note="{ item }">
					<div class="pt-2">{{ item.trx_cancel_note }}</div>
				</template>
				<template v-slot:item.trx_cancel_administrator_name="{ item }">
					<div class="pt-2">{{ item.trx_cancel_administrator_name }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!paginationData">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="paginationData">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{paginationData.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="paginationData.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import filterComponent from '@/components/Filter'
import ModalDetailCancelTransaction from './components/ModalDetailCancelTransaction'


export default {
	inject: ['theme'],
	components: {
		filterComponent, ModalDetailCancelTransaction
	},
	data() {
		return {
			sortBy: 'trx_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', align: 'center', value: 'action', sortable: false },
			{ text: 'Kode Transaksi', align: 'start', value: 'trx_cancel_trx_code', sortable:false},
			{ text: 'Tanggal Pembatalan Transaksi', align: 'start', value: 'trx_cancel_datetime', sortable: false},
			{ text: 'Alasan Pembatalan', align: 'start', value: 'trx_cancel_note', sortable: false},
			{ text: 'Dibatalkan Oleh', align: 'start', value: 'trx_cancel_administrator_name', sortable: false},
			],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Transaksi',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'trx_cancel_trx_code'
				}
			}, {
				type: 'date',
				show: false,
				label: 'Tanggal Transaksi',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'trx_cancel_datetime'
				}
			}
			],
		}
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('ecommerceTransaction', ['listData', 'paginationData', 'listStatus']),
	},
	methods: {
		...mapActions('ecommerceTransaction', ['getTransactionCancel', 'exportTransactionCanceled', 'getDetailTransaction', 'getStatusListTransaction']),
		...mapMutations(['setFilter']),
		...mapMutations('ecommerceTransaction', ['setDetailTransaction','clearDataTransaction']),

		maxLength(val, max) {
			let text = val
			if (text.length > max)
				text = text.slice(0,max) + '...'
			return text
		},
		getData() {
			this.getTransactionCancel(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		// exportData() {
		// 	this.exportTransactionCanceled(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		// },
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		async getDetail(item) {
			let data = item.trx_cancel_data
			this.setDetailTransaction(data)
			this.$refs.ModalDetailCancelTransaction.showModal()	
		},
	},
	beforeDestroy(){
		this.clearDataTransaction()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Transaction Ecommerce`)
		await this.getData()

		await this.setFilter(this.filterData)
	},
};
</script>